import { atom } from "jotai";

export const isLocationDeletedAtom = atom(false);
